const katex = require('katex');

/**
 * Define bra-ket notation macros for quantum mechanics.
 */
katex.__defineMacro('\\bra', '\\mathinner{\\langle{#1}|}');
katex.__defineMacro('\\ket', '\\mathinner{|{#1}\\rangle}');
katex.__defineMacro('\\braket', '\\mathinner{\\langle{#1}\\rangle}');
katex.__defineMacro('\\Bra', '\\left\\langle#1\\right|');
katex.__defineMacro('\\Ket', '\\left|#1\\right\\rangle');
katex.__defineMacro('\\ketbra', '\\ket{#1}\\bra{#2}');

/**
 * Commonly used macros which are just aliases for other commands.
 */
katex.__defineMacro('\\overparen', '\\overgroup{#1}');
katex.__defineMacro('\\mbox', '\\text{#1}');
katex.__defineMacro('\\pmatrix', '\\begin{pmatrix}#1\\end{pmatrix}');
katex.__defineMacro('\\longdiv', '\\overline{\\smash{\\big)}#1}');
katex.__defineMacro('\\cases', '\\begin{cases}#1\\end{cases}');
katex.__defineMacro('\\cancelto', '\\cancel{#2}^{~~#1}');

/**
 * Pix colors -- these are the dark versions, for good contrast.
 * Usage: \\blue{a^2} + \\red{b^2} = \\yellow{c^2}
 */
katex.__defineMacro('\\yellow', '\\textcolor{DF9912}{#1}');
katex.__defineMacro('\\blue', '\\textcolor{1757D7}{#1}');
katex.__defineMacro('\\red', '\\textcolor{DA4631}{#1}');
katex.__defineMacro('\\green', '\\textcolor{19866C}{#1}');
katex.__defineMacro('\\purple', '\\textcolor{6D22CC}{#1}');
katex.__defineMacro('\\pink', '\\textcolor{C347D7}{#1}');

/**
 * Currencies. Some already supported, and this adds convenience macros for them.
 * Others not supported yet, so we support them ourselves.
 * https://github.com/KaTeX/KaTeX/issues/1107
 */
katex.__defineMacro('\\dollar', '\\${#1}');
katex.__defineMacro('\\dollars', '\\$');
katex.__defineMacro('\\euro', '€{#1}');
katex.__defineMacro('\\euros', '€');
katex.__defineMacro('\\pound', '\\pounds{#1}');
katex.__defineMacro('\\bitcoin', '₿{#1}');
katex.__defineMacro('\\bitcoins', '₿');
katex.__defineMacro('\\dogecoin', 'Ð{#1}');
katex.__defineMacro('\\dogecoins', 'Ð');
